import '../../common_screen/contest_details/index_mWeb.css';

import { View, HeaderWithTimer, Text, RouteWrapper } from '../../../component';
import { ContestShare } from '../../component';
import SwipeableViews from 'react-swipeable-views';
import ContestDetailsTabBar from '../../component/contest_details_tab_bar';
import { useLink } from 'react-router-stack';
import I18n from '../../../utilities/locale';
import useTheme from '../../../utilities/hooks/theme';
import ContestCardMWeb from '../../component/contest_card/index_mWeb';
import ContestLeaderboardMWeb from '../../component/contest_leaderboard/index_mWeb';
import ContestDetailsWinningBreakupMWeb from '../../component/contest_details_winning_breakup/index_mWeb';
import ScreenBackgroundWrapper from '../../../component/screen_background_wrapper';
const ContestDetailsMWeb = ({
  contestDetail,
  onPressShare,
  matchStatus,
  gameState,
  matchItem,
  totalTeamsCount,
  matchDelayed,
  gameType,

  getContestUserLeaderboard,
  getContestLeaderboard,
  fantasyMatchClick,
  completed,
  contestId,
  userId,
  winningsPerPosition,
  entryFee,
  tabType,
  matchVerifiedStatus,
  bonusPercentage,
  matchId,
  getPlayerList,
  matchTeamLock,
  myTeamList,
  isGadgetLeague_,
  description,

  winningData,
  contestLink,
  contestTitle,
  contestShare,
  onPressShareModalDismiss,
  questionList,
  routes,
  onChangeTabIndex,
  onChangeTab,
  activeTab
}: any) => {
  const { FantasyTheme: theme } = useTheme();
  const navigate = useLink();

  const onPressBack = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  const footerTitle = {
    color: theme.contestDetailsFooterText
  };

  return (
    <RouteWrapper>
      <ScreenBackgroundWrapper>
        <HeaderWithTimer
          onPressBack={onPressBack}
          matchItem={matchItem}
          tabType={tabType}
          gameType={gameType}
        />

        <ContestCardMWeb
          isContestDetails={true}
          contest={contestDetail}
          onPressCard={() => {}}
          onPressShare={() => onPressShare(contestDetail)}
          matchStatus={matchStatus}
          gameState={gameState}
          matchItem={matchItem}
          totalTeamsCount={totalTeamsCount}
          screenName={'CONTEST_DETAILS'}
          matchDelayed={matchDelayed}
          gameType={gameType}
        />
        <View className={'contest-details-tab-view-wrapper_mWeb'}>
          <View
            style={{
              flexGrow: 1,
              height: '100%'
            }}>
            <ContestDetailsTabBar onChangeTab={onChangeTab} activeTab={activeTab} routes={routes} />
            <div className="flat-list-outer-grow">
              <SwipeableViews
                index={activeTab}
                onChangeIndex={onChangeTabIndex}
                className={'contest-details-swipeable-view_mWeb'}>
                <ContestDetailsWinningBreakupMWeb
                  winningData={winningData}
                  isGadgetLeague={isGadgetLeague_}
                  description={description}
                />
                <ContestLeaderboardMWeb
                  getContestUserLeaderboard={getContestUserLeaderboard}
                  getContestLeaderboard={getContestLeaderboard}
                  fantasyMatchClick={fantasyMatchClick}
                  completed={completed}
                  matchStatus={matchStatus}
                  matchItem={matchItem}
                  contestId={contestId}
                  userId={userId}
                  winningsPerPosition={winningsPerPosition}
                  entryFee={entryFee}
                  tabType={tabType}
                  matchVerifiedStatus={matchVerifiedStatus}
                  bonusPercentage={bonusPercentage}
                  gameState={gameState}
                  matchId={matchId}
                  getPlayerList={getPlayerList}
                  matchTeamLock={matchTeamLock}
                  gameType={gameType}
                  myTeamListLen={myTeamList.length}
                  isGadgetLeague={isGadgetLeague_}
                  description={description}
                  questionList={questionList}
                />
              </SwipeableViews>
            </div>
          </View>
          <View style={{ alignItems: 'center' }}>
            <Text className={'contest-details-footer-title_mWeb'} style={footerTitle}>
              {I18n.t('DeductionOver10000')}
            </Text>
          </View>
        </View>
        <ContestShare
          link={contestLink}
          contestTitle={contestTitle}
          visible={contestShare}
          onPressDismiss={onPressShareModalDismiss}
        />
      </ScreenBackgroundWrapper>
    </RouteWrapper>
  );
};
export default ContestDetailsMWeb;
